
import { defineComponent, PropType, computed } from '@vue/composition-api';
import { IconButton } from '@fc/angie-ui';

export type ArticleCardVariant = 'featured' | 'text-only';

export default defineComponent({
  name: 'ArticleCard',
  components: {
    IconButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    source: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      default: '',
    },
    variant: {
      type: String as PropType<ArticleCardVariant>,
      default: 'featured',
      validator: (value: string) => ['featured', 'text-only'].includes(value),
    },
  },
  setup(props: { variant: ArticleCardVariant }) {
    const isFeatured = computed(() => props.variant === 'featured');
    const isTextOnly = computed(() => props.variant === 'text-only');

    const cardClasses = computed(() => ({
      'article-card': true,
      'article-card--featured': isFeatured.value,
      'article-card--text-only': isTextOnly.value,
    }));

    return {
      isFeatured,
      isTextOnly,
      cardClasses,
    };
  },
});
